/**
 * @license Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgb(0, 0, 0, 0.7);
}

.modal {
  position: relative;
  width: 60vw;
  min-width: 400px;
  max-width: 800px;
  background: var(--highlighted-background-color);
  padding: var(--base-spacing);
  padding-right: calc(var(--base-spacing) * 2);
}

.modal__close {
  position: absolute;
  top: calc(var(--base-spacing) / 2);
  right: calc(var(--base-spacing) / 2);
  cursor: pointer;
}
